module.exports = __webpack_public_path__ + "fonts/glyphicons-halflings-regular.eot";


//////////////////
// WEBPACK FOOTER
// ./~/@ps/common-core/dist/fonts/glyphicons-halflings-regular.eot
// module id = ./node_modules/@ps/common-core/dist/fonts/glyphicons-halflings-regular.eot
// module chunks = 1